import { forwardRef, type ReactNode } from 'react'
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch as MuiSwitch,
  type FormControlLabelProps,
  type FormControlProps,
  type SwitchProps as MuiSwitchProps,
} from '@mui/material'

export type SwitchProps = Omit<MuiSwitchProps, 'children'> & {
  error?: boolean
  formControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'disabled' | 'label' | 'required'>
  formControlProps?: Omit<FormControlProps, 'disabled' | 'error' | 'required'>
  helperText?: ReactNode
  label?: ReactNode
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { error = false, formControlLabelProps, formControlProps, helperText, label, slotProps, ...props },
  ref,
) {
  const inputSlotProps = slotProps?.input

  const control = (
    <MuiSwitch
      {...props}
      slotProps={{
        ...slotProps,
        input:
          typeof inputSlotProps === 'function'
            ? ownerState => {
                const resolved = inputSlotProps(ownerState)

                return {
                  ...resolved,
                  ref,
                }
              }
            : {
                ...(slotProps?.input ?? {}),
                ref,
              },
      }}
    />
  )

  if (!label && !helperText) {
    return control
  }

  return (
    <FormControl {...formControlProps} disabled={props.disabled} error={error} required={props.required}>
      {label ? <FormControlLabel {...formControlLabelProps} control={control} label={label} /> : control}
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  )
})
